import { TouchableOpacity } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Box, HStack, IBoxProps } from 'native-base';

import { Text } from '@pimm/base';
import { useState } from 'react';

export type AttentionType = 'all' | 'action_required' | 'low_levels';

export type AttentionTabs = IBoxProps & {
  activeTab?: AttentionType;
  lowLevels: number;
  requireActions: number;
  onChangeTab: (value: AttentionType) => void;
};

const AttentionTabs = ({ activeTab = 'all', lowLevels, requireActions, onChangeTab, ...props }: AttentionTabs) => {
  const { t } = useTranslation();
  const [tabItems] = useState<AttentionType[]>(['all', 'action_required', 'low_levels']);

  return (
    <HStack p={1} backgroundColor="gray.200" rounded="md" {...props}>
      {tabItems.map(_tab => {
        const count = _tab === 'action_required' ? requireActions : lowLevels;
        return (
          <Box key={_tab} flex={1}>
            <TouchableOpacity disabled={count === 0} onPress={() => onChangeTab(_tab)}>
              <HStack
                alignItems="center"
                justifyContent="center"
                opacity={count ? 1 : 0.2}
                space={2}
                height={9}
                backgroundColor={_tab === activeTab ? 'white' : undefined}
                rounded="md"
              >
                <Text size="sm" fontWeight={700} color="black">
                  {t(`coke_freestyle:${_tab}`)}
                </Text>
                {_tab !== 'all' && (
                  <Box width={10} backgroundColor={_tab === 'action_required' ? 'red.500' : 'yellow.500'} rounded="md">
                    <Text size="md" fontWeight={700} color="white" textAlign="center">
                      {count}
                    </Text>
                  </Box>
                )}
              </HStack>
            </TouchableOpacity>
          </Box>
        );
      })}
    </HStack>
  );
};

export default AttentionTabs;
